var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.10799 14.3151L7.46154 14.6686L8.16864 13.9615L7.81509 13.608L7.10799 14.3151ZM1 7.49999L0.646447 7.14644L0.292893 7.49999L0.646447 7.85354L1 7.49999ZM7.81509 1.39201L8.16864 1.03845L7.46154 0.331345L7.10799 0.684899L7.81509 1.39201ZM7.81509 13.608L1.35355 7.14644L0.646447 7.85354L7.10799 14.3151L7.81509 13.608ZM1.35355 7.85354L7.81509 1.39201L7.10799 0.684899L0.646447 7.14644L1.35355 7.85354ZM1 7.99999H22V6.99999H1V7.99999Z","fill":"black"}));
}

Arrow.defaultProps = {"width":"22","height":"15","viewBox":"0 0 22 15","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
